import { LogoItem } from '../logo-block/logo-block';
import { resolveStrapiMediaUrl } from '../../../core/utils/strapi-media.util';

export function adaptLogoSection(
  entry: Record<string, unknown>,
  baseUrl: string,
): Record<string, unknown> {
  const rawLogos = entry['logos'];
  const logos: LogoItem[] = Array.isArray(rawLogos)
    ? rawLogos.map((logo: Record<string, unknown>) => {
        const img = logo['image'] as Record<string, unknown> | null;
        return {
          src: img
            ? resolveStrapiMediaUrl(baseUrl, (img['url'] as string) ?? null) ?? ''
            : '',
          alt:
            (logo['alt'] as string) ??
            (typeof img === 'object' && img
              ? (img['alternativeText'] as string) ?? ''
              : ''),
          width: img ? (img['width'] as number) ?? 0 : 0,
          height: img ? (img['height'] as number) ?? 0 : 0,
          href: (logo['href'] as string) ?? undefined,
        };
      })
    : [];

  return {
    sectionId: (entry['htmlId'] as string) ?? '',
    heading: (entry['heading'] as string) ?? '',
    background: (entry['background'] as string) ?? '',
    logos,
    cssClass: (entry['cssClass'] as string) ?? '',
  };
}
